import React from 'react';
import ReactDOM from 'react-dom';
import Immutable from 'immutable';
import Iso from 'iso';
import httpClient from 'superagent';
import { Provider } from 'react-redux';
import { loadableReady } from '@loadable/component';
import BCGoogleAnalyticsUtils from '@bibliocommons/utils-google-analytics';

import ApiClient from './api/ApiClient';
import ErrorService from './services/ErrorService';
import { selectCurrentLibrary } from './selectors/LibrarySelector';
import createReduxStore from './helpers/redux/createReduxStore';
import ApplicationContainer from './ApplicationContainer';
import ApplicationRouter from './ApplicationRouter';

// Prevent safari loading from cache when back button is clicked
window.onpageshow = function handleSafariBFCache(event) {
  if (event.persisted && typeof window.parentIFrame === 'undefined') {
    window.location.href += '&reload=true';
  }
};

// Boot up the React application
Iso.bootstrap(reduxStoreData => {
  const rootElement = document.getElementById('react-root');

  const {
    apiGatewayURL,
    libraryDomain,
    sessionId,
    authToken,
    airbrakeConfig,
    gaTrackingId,
    enableWebpackHMR,
    enableReduxDevTools
  } = reduxStoreData.app;

  const reduxState = Immutable.fromJS(reduxStoreData);
  const currentLibrary = selectCurrentLibrary(reduxState);
  const currentLanguage = reduxStoreData.localization.currentLanguage;

  ErrorService.initialize(airbrakeConfig);
  BCGoogleAnalyticsUtils.initialize(gaTrackingId, currentLibrary.toJS(), currentLanguage);

  const apiClient = new ApiClient(httpClient, {
    subdomain: libraryDomain,
    locale: currentLanguage,
    apiGatewayURL,
    sessionId,
    authToken
  });

  const reduxStore = createReduxStore(reduxState, apiClient, enableWebpackHMR, enableReduxDevTools);

  loadableReady(() => {
    ReactDOM.hydrate(
      <Provider store={reduxStore}>
        <ApplicationContainer>
          <ApplicationRouter />
        </ApplicationContainer>
      </Provider>,
      rootElement
    );
  });
});
